/**
 * KAN-877: подписи адресатов звонка. Кнопка: "Позвонить <имя>", у ЛПР
 * "Позвонить ЛПР: <имя>". В выборе: имя (или слово роли) и строка роли.
 */
import type { CallTarget, CallTargetKind } from '@/services/api/callTargets';

export const CALL_TARGETS_ERROR = 'Не удалось узнать, кому звонить';
export const CALL_TARGETS_ERROR_TOAST = `${CALL_TARGETS_ERROR}. Попробуйте ещё раз`;

/** Человек карточки: клиент или контакт по рекомендации, на которого заведена карточка. */
export function isCardPersonTarget(target: CallTarget): boolean {
  return target.target === 'client' || target.target === 'referral';
}

/** Выбор нужен, если адресатов несколько или единственный не человек карточки. */
export function callTargetsNeedChoice(targets: CallTarget[]): boolean {
  return targets.length > 1 || (targets.length === 1 && !isCardPersonTarget(targets[0]));
}

const KIND_WORD: Record<CallTargetKind, string> = {
  client: 'Клиент',
  decision_maker: 'ЛПР',
  referral: 'Контакт',
};

const NAMELESS_BUTTON: Record<CallTargetKind, string> = {
  client: 'Позвонить клиенту',
  decision_maker: 'Позвонить ЛПР',
  referral: 'Позвонить контакту',
};

function cleanName(target: CallTarget): string {
  return (target.name ?? '').trim();
}

export function callTargetButtonLabel(target: CallTarget): string {
  const name = cleanName(target);
  if (!name) return NAMELESS_BUTTON[target.target] ?? 'Позвонить';
  return target.target === 'decision_maker' ? `Позвонить ЛПР: ${name}` : `Позвонить ${name}`;
}

export function callTargetTitle(target: CallTarget): string {
  return cleanName(target) || KIND_WORD[target.target] || 'Контакт';
}

/** Строка роли в выборе: у ЛПР всегда "ЛПР" (и должность), у остальных должность или слово роли. */
export function callTargetRoleText(target: CallTarget): string {
  const role = (target.role ?? '').trim();
  if (target.target === 'decision_maker') return role ? `ЛПР, ${role}` : 'ЛПР';
  return role || KIND_WORD[target.target] || '';
}
